import dash_api from 'client/js/main/support/dash_api';
import type { AdsActivityConfig } from '../../../../../../shared/types/AdsActivityConfig';
import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_ADS_ACTIVITY_CONFIG = 'UPDATE_ADS_ACTIVITY_CONFIG' as const;

export const updateAdsActivityConfig = (config: AdsActivityConfig) => {
  dash_api.put('/v1/ads/analytics/view', config).catch(() => {
    // ignore error as the server will be updated, just the database won't be.
    // if the user refreshes the page, the view will revert to the previous state and they can try again.
  });

  return { type: UPDATE_ADS_ACTIVITY_CONFIG, data: config };
};

export type UpdateAdsActivityConfigResponseAction = DataAction<typeof UPDATE_ADS_ACTIVITY_CONFIG, AdsActivityConfig>;
